import './course_view.css';
import imagePlaceholder from '../../assets/img/jpg/img_placeholder.jpg';
import { Header } from "../../components/header/Header";
import { useAuth } from "../../context/AuthContext";
import { Link, useLocation, useParams } from 'react-router-dom';
import { useLang } from '../../context/LangContext';
import { useServer } from '../../context/serverContext';
import { useEffect, useState } from 'react';
import { backendEnv, endpoints } from '../../env';
import { CourseViewModule } from '../../components/CourseViewModule/CourseViewModule';
import { Footer } from '../../components/footer/Footer';
import Buy from '../../components/Buy/Buy';

export function CourseView() {
    //HOOKS
    const { user, isAuth, getTimes } = useAuth();
    const { lang } = useLang();
    const { getRequest } = useServer();
    const { id } = useParams();
    const { state } = useLocation();

    //STATES
    const [course, setCourse] = useState(state ? state.course : null);
    const [duration, setDuration] = useState(null);
    const [image, setImage] = useState(imagePlaceholder);
    const [isMember, setIsMember] = useState(null);
    const [message, setMessage] = useState(false);
   

    useEffect(() => {
        // Extraer el mensaje de la URL actual
        const searchParams = new URLSearchParams(window.location.search);
        const messageParam = searchParams.get('msg');
            
        if (messageParam) {
            setMessage(messageParam);
        }
         


        if(user !== null){
            getTimes(user.id);
        }

        let data = {
            course_id: id,
        }
       
        getRequest(endpoints.getCourse, data, (res) => {
        
            if (res[0]) {
                res = res[1];
                setCourse(res.course);
                setIsMember(res.access);
            }
        });

        getRequest(endpoints.getCourseDuration, data, (res) => {
            if (res[0]) {
                res = res[1];
                setDuration(res);
            }
        });
        
    }, []);

    useEffect(() => {
        if (course !== null) {
            if (course.picture !== null) {
                setImage(backendEnv.url + '/api/public/v1/course/'+id+'/image/get');
            }
        }
    }, [course, id]);

   

    return (
        <>
            <Header />
            <div className="course_view_breadcrumb">
                <div className='path'>
                    <Link to='/courses'>
                        {lang === "en" ? "Academies" : "Academias"} /
                    </Link>
                    <Link to={'/course/'}>
                        &nbsp;{ course && (course.en && lang === "en" ? course.en.name : course.name) }
                    </Link>
                </div>
            </div>
            
            <div className='course_view_banner_responsive'>
                <h2>
                    { course && (course.en && lang === "en" ? course.en.name : course.name) }
                </h2>
            </div>
            <div className='course_view_banner'>
                <h1>
                    { course && (course.en && lang === "en" ? course.en.name : course.name) }

                </h1>
            </div>

            

            <div className='course_view_nav'>
                <div className='image'>
                    <img src={image} alt='' />
                </div>
                <div className='nav_item'>
                    <i className="fa-solid fa-house"></i>
                    { lang === "en" ? "Academy" : "Academia" }
                </div>
            </div>
          
            <section className='course_view_body'>
                
                <div className='info_col'>
                {message && (<div className="message">
                Academy successfully purchased</div> )}
                    <div className='container'>
                        { isAuth !== null && user === null &&
                            (
                                <div className='private_disclaimer'>
                                   
                                    <h2>
                                        { lang === "en" ? "Private course" : "Curso privado"}
                                    </h2>
                                    {
                                        lang === "en" ? (
                                            <p>
                                                <Link to={'/login'}>Login</Link> to access this course
                                            </p>
                                        ) : (
                                            <p>
                                                <Link to={'/login'}>Inicia sesión</Link> para acceder a este curso
                                            </p>
                                        )
                                    }
                                </div>
                            )
                        }
                        {
                            user && isMember !== null && !isMember &&
                            (
                                <div className='private_disclaimer'>
                                    <h2>
                                        { lang === "en" ? "Private course" : "Curso privado"}
                                    </h2>
                                    {
                                        lang === "en" ? (
                                            <p>
                                                You do not have access to this course
                                            </p>
                                        ) : (
                                            <p>
                                                No tienes acceso a este curso
                                            </p>
                                        )
                                    }
                                   
                                </div>
                                
                            )
                        }
                        
                        <div className='course_length'>
                            <h2>{ lang === "en" ? "Duration" : "Duración"}: </h2>
                            <p>
                                { duration && 
                                    (
                                        duration.minutes >= 60 ? (
                                            duration.hours + " " + (lang === "en" ? "Hours" : "Horas")
                                        ) : (
                                            duration.minutes + " " + (lang === "en" ? "Minutes" : "Minutos")
                                        )
                                    )
                                }
                            </p>
                        </div>
                        <Buy idCourse={id} isMember={isMember}></Buy>
                    </div>
                </div>
                <div className='course_view_content'>
                    
                    {
                        course && course.modules && course.modules.map((module, index) => {
                            return <CourseViewModule module={module} isMember={isMember} courseId={course.id} course={course} key={'course_view_module' + module.id} />
                        })
                    }
                </div>
            </section>

            <Footer />
        </>
    );
}